module.exports = __webpack_public_path__ + "static/media/dr-bot.a1d15708.svg";